import useFloatingHeaderSelectors from './useFloatingHeaderSelectors';

export default useFloatingHeaderSelectors;